export const labelFor = (options, value) => options.find((o) => o.value === value)?.label || value || "";
export const labelsForMulti = (options, values) =>
  Array.isArray(values) && values.length ? values.map((v) => labelFor(options, v)).join(", ") : "";